import React, { Component } from 'react';
import { Divider, Switch, Slider, Button } from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class Academy extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      AcademySystem: true,
      CreateAcademy: true,
      AcademyCreationLevel: 60,
    };

    this.handleChange = (Name) => (Value) => {
      if (typeof this.state[Name] === 'boolean')
        this.setState({ [Name]: !this.state[Name] });
      else if (Value.target) this.setState({ [Name]: Value.target.value });
      else this.setState({ [Name]: Value });
    };
  }

  render() {
    const SwitchOnOff = { innerLabelChecked: 'on', innerLabel: 'off' };

    return (
      <SideMenuWrapper>
        <h3
          className="display-4 font-italic mb-4"
          style={{ fontSize: '1.5rem' }}
        >
          Academy
        </h3>

        <Divider />

        <table className="bp3-html-table bp3-html-table-bordered bp3-interactive html-table-row-border">
          <tbody>
            <tr>
              <td>Academy System</td>
              <td>
                <Switch
                  checked={this.state.AcademySystem}
                  {...SwitchOnOff}
                  onChange={this.handleChange('AcademySystem')}
                />
              </td>
            </tr>

            <tr>
              <td>Create Academy</td>
              <td>
                <Switch
                  disabled={!this.state.AcademySystem}
                  checked={this.state.CreateAcademy}
                  {...SwitchOnOff}
                  onChange={this.handleChange('CreateAcademy')}
                />
              </td>
            </tr>

            <tr>
              <td>Academy Creation Level</td>
              <td style={{ width: '360px' }}>
                <Slider
                  intent={
                    this.state.AcademyCreationLevel >= 90
                      ? 'success'
                      : this.state.AcademyCreationLevel >= 60
                      ? 'primary'
                      : this.state.AcademyCreationLevel >= 50
                      ? 'warning'
                      : 'danger'
                  }
                  disabled={
                    !this.state.AcademySystem || !this.state.CreateAcademy
                  }
                  min={20}
                  max={120}
                  labelStepSize={10}
                  onChange={this.handleChange('AcademyCreationLevel')}
                  value={this.state.AcademyCreationLevel}
                  className="mb-4"
                />
              </td>
            </tr>

            <tr>
              <td></td>
              <td>
                <Button className="mt-2" icon="floppy-disk" text="Save" />
              </td>
            </tr>
          </tbody>
        </table>
      </SideMenuWrapper>
    );
  }
}
